import {Injectable, Injector} from '@angular/core';
import {Utilities} from '@shared/utilities/utilities.model';
import {RequestOptionsArgs} from '@angular/http';
import {InnerMessageAuthorityMessageCode} from './inner-message-authority-utilities';
import {AuthorityBaseService} from './authority-base.service';
import {MessageComponentType, MessageDetail, MessageType} from '@shared/service/message-manager/message.model';
import {MessageManagerUtilities} from '@shared/service/message-manager/message-manager-utilities';

@Injectable({
	providedIn: 'root'
})
export class WarrantyService extends AuthorityBaseService {

	constructor(protected injector: Injector) {
		super(injector);
	}

	updateSingleWarranty(
		dossierId: string, workingId: string, quotationId: string, entryId: string, warrantyRequest: UpdateWarrantyRequestBody,
		onSuccess: (successMessage: MessageDetail) => void, onFailure: (errorMessage: MessageDetail) => void
	): void {
		const url: string = `${this.environment.AUTHORITY}/dossiers/${dossierId}/workings/${workingId}/quotations/${quotationId}/entries/${entryId}/warranty_type`;
		const options: RequestOptionsArgs = Utilities.setOptionsWithNemoCommodityID([]);
		this.httpAuthService.patch(url, warrantyRequest, this.redirectUrl, options).subscribe(
			response => {
				if (response.ok) {
					onSuccess(
						{
							type: MessageType.TYPE_SUCCESS,
							code: (
								warrantyRequest.warranty_type === WarrantyTypes.EX ?
									InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_UPDATE_SINGLE_WARRANTY_EX :
									InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_UPDATE_SINGLE_WARRANTY
							),
							componentType: MessageComponentType.SNACK_BAR
						}
					);
				} else {
					onFailure(
						{
							type: MessageType.TYPE_ERROR,
							code: InnerMessageAuthorityMessageCode.AUTHORITY_GENERIC_SERVICE_ERROR,
							componentType: MessageComponentType.SNACK_BAR
						}
					);
				}
			}, error => onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error))
		);
	}

	updateMultiWarranty(
		dossierId: string, workingId: string, quotationId: string, warrantyRequest: MultiUpdateWarrantyRequestBody,
		onSuccess: (successMessage: MessageDetail) => void, onFailure: (errorMessage: MessageDetail) => void
	): void {
		const url: string = `${this.environment.AUTHORITY}/dossiers/${dossierId}/workings/${workingId}/quotations/${quotationId}/entries/warranty_type`;
		const options: RequestOptionsArgs = Utilities.setOptionsWithNemoCommodityID([]);
		this.httpAuthService.patch(url, warrantyRequest, this.redirectUrl, options).subscribe(
			response => {
				if (response.ok) {
					onSuccess(
						{
							type: MessageType.TYPE_SUCCESS,
							code: (
								warrantyRequest.warranty_type_request.warranty_type === WarrantyTypes.EX ?
									InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_UPDATE_MULTI_WARRANTY_EX :
									InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_UPDATE_MULTI_WARRANTY
							),
							componentType: MessageComponentType.SNACK_BAR
						}
					);
				} else {
					onFailure(
						{
							type: MessageType.TYPE_ERROR,
							code: InnerMessageAuthorityMessageCode.AUTHORITY_GENERIC_SERVICE_ERROR,
							componentType: MessageComponentType.SNACK_BAR
						}
					);
				}
			},
			error => onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error))
		);
	}
}

export interface MultiUpdateWarrantyRequestBody {
	id_list: string[];
	warranty_type_request: UpdateWarrantyRequestBody;
}

export interface UpdateWarrantyRequestBody {
	warranty_type: WarrantyTypes;
	discount_percentage?: number;
	note?: string;
}

export enum WarrantyTypes {
	G1 = 'G1',
	G2 = 'G2',
	EX = 'EX'
}
